import gsap from "gsap";

import ScrollTrigger from "gsap/dist/ScrollTrigger";
import { initOnScrollAnimation } from "../../../src/js/modules/on-scroll-animations";

gsap.registerPlugin(ScrollTrigger);

document.querySelectorAll(".footer").forEach((el) => {
	const bg = el.querySelector(".js-bg");

	if (bg) {
		ScrollTrigger.create({
			trigger: el,
			start: "top bottom",
			scrub: true,
			end: "bottom top",
			animation: gsap.fromTo(bg, { y: "-2rem" }, { y: "2rem" }),
		});
	}

	initOnScrollAnimation(el);
});
